import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"
import type RotationEditor from "cc-frontend/services/rotation-editor"

interface Args {
  rotationCalendar: RotationCalendar
  courses: Array<Course>
  planbook: Planbook
  closeMenu: Function
  dateString: string
}

export default class DayMenuChangeSchooolYearDates extends Component<Args> {
  //services
  @service("ember-store") store!: EmberStore
  @service rotationEditor!: RotationEditor

  @action changeStartOfSchoolYear() {
    this.args.closeMenu()
    this.rotationEditor.changeSchoolYearDates({
      courses: this.args.courses,
      planbook: this.args.planbook,
      rotationCalendar: this.args.rotationCalendar,
      dateString: this.args.dateString,
      startOrEnd: "START",
    })
  }
}
